import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { api, errMsg } from "../../lib/api";
import { BatchFields, IssuedDialog, emptyBatch } from "./InvitationDialogs";

export const passLabel = (p) => (p ? (!p.paid ? `${p.package_name || "Custom"}: 0 passes until paid (${p.allowance_when_paid} once paid)` : `${p.package_name || "Custom"}: ${p.allowance} passes, ${p.allocated} allocated, ${p.redeemed} redeemed`) : "—");

export function GeneratePassesDialog({ sponsor, summary, onClose, onDone }) {
  const [v, setV] = useState({ ...emptyBatch(), mode: "quantity", quantity: Math.max(1, (summary?.allowance || 0) - (summary?.allocated || 0)) });
  const [busy, setBusy] = useState(false);
  const [issued, setIssued] = useState(null);
  const set = (p) => setV((s) => ({ ...s, ...p }));
  const remaining = (summary?.allowance || 0) - (summary?.allocated || 0);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await api.post(`/admin/sponsors/${sponsor.id}/passes`, { expires_on: v.expires_on, label: v.label,
        quantity: v.mode === "quantity" ? v.quantity : 0, csv_text: v.mode === "csv" ? v.csv_text : "" });
      setIssued(data); onDone();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  if (issued) return <IssuedDialog data={issued} onClose={onClose} />;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl" data-testid="generate-passes-dialog">
        <DialogHeader><DialogTitle>Generate passes: {sponsor.company}</DialogTitle></DialogHeader>
        <p className="text-sm text-navy" data-testid="passes-summary">{passLabel(summary)} · <b>{remaining} remaining</b></p>
        <form onSubmit={submit} className="space-y-4">
          <div><label htmlFor="passes-label" className="field-label">Batch label (optional)</label>
            <input id="passes-label" className="field-input" value={v.label} onChange={(e) => set({ label: e.target.value })} data-testid="passes-label-input" /></div>
          <BatchFields v={v} set={set} />
          <button type="submit" className="btn-primary" disabled={busy || remaining <= 0} data-testid="passes-generate-submit-btn">{busy ? "Generating…" : "Generate passes"}</button>
          {remaining <= 0 && <p className="field-error">Allowance fully allocated. Revoke unused passes or raise the override to issue more.</p>}
        </form>
      </DialogContent>
    </Dialog>
  );
}
